import { incomeReporting } from "byzantine";

import { IncomeReportingForm } from "./IncomeReportingForm";

import type { IncomeReportingDialogProps } from "./types";

const { incomeReportingForm, incomeSourceToFormValues } = incomeReporting;
const { Provider: IncomeReportingProvider } = incomeReportingForm;

interface IncomeReportingContainerProps {
  DialogFormProps: IncomeReportingDialogProps;
  /**
   * Used to populate form for editing an IncomeSource
   */
  initialValues?: API.IncomeSource;
}

/**
 * Mounts the IncomeReporting provider. The Dialog and Form components are children.
 */
export const IncomeReportingContainer = ({
  DialogFormProps,
  initialValues,
}: IncomeReportingContainerProps) => {
  const formattedIncomeSource = initialValues
    ? incomeSourceToFormValues(initialValues)
    : undefined;
  return (
    <IncomeReportingProvider initialValues={formattedIncomeSource}>
      <IncomeReportingForm {...DialogFormProps} uuid={initialValues?.uuid} />
    </IncomeReportingProvider>
  );
};
